export class DirectLoadError extends Error {

    constructor(msg) {
        super(msg);
    }

}
